import React, { useEffect, useState } from 'react';
import { useGridApiRef } from '@mui/x-data-grid-pro';
import { Grid, Paper, TextField, Typography, debounce } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { XGrid } from 'app/components/Common/XGrid/XGrid';
import { useTranslation } from 'react-i18next';
import { getEvaluationColumns } from './ReferenceUtils';
import { useAddEditReferenceStyle } from './AddEditReference.style';

const ReferenceEvaluation = ({ evaluation, disabled }: { evaluation: any; disabled: boolean }) => {
  const { t } = useTranslation();
  const { classes } = useAddEditReferenceStyle();
  const apiRef = useGridApiRef();
  const [columns, setColumns] = useState<any>([]);
  useEffect(() => {
    setColumns(getEvaluationColumns());
  }, []);

  return (
    <Paper variant="outlined" square>
      <Grid container justifyContent={'space-between'} alignItems={'center'} p={2}>
        <Typography component={'h4'} className={classes.AdditionalInfoTitle}>
          {t('candidate.workExperience.addEditReference.referenceAdditionalInfo.evaluation')}
        </Typography>
        <Grid item xs={7}>
          <TextField
            variant="outlined"
            size="small"
            color="primary"
            placeholder={'Search'}
            id="searchReferenceEvaluation"
            autoComplete="on"
            onChange={debounce(() => {}, 300)} //To-Do : Implement onChange Function
            InputProps={{
              startAdornment: <SearchIcon sx={{ opacity: 0.6 }} />,
            }}
            disabled={disabled}
          />
        </Grid>
      </Grid>
      <Grid xs={12} p={2} pt={0}>
        <XGrid
          apiRef={apiRef}
          columns={columns}
          getRowId={row => row.categoryTypeID}
          rows={evaluation || []}
          autoHeight={false}
          height={300}
          disablePaggination={true}
          disableSelectionOnClick
          toolbar={false}
          hideFooter={true}
        />
      </Grid>
    </Paper>
  );
};

export default React.memo(ReferenceEvaluation);
